import React, { useState, useEffect, useContext } from 'react';
import {
    createMuiTheme, Slide, Container, Dialog, AppBar, Toolbar, IconButton, Typography, Fab, CssBaseline
    , FormControlLabel, Checkbox, Tooltip, Backdrop, CircularProgress, Grid
} from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { ThemeProvider } from '@material-ui/styles';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import styles from "../../../jss/material-dashboard-react/views/dashboardStyle.js";
import { GlobalTheme } from '../../../layouts/theme';
import { Theme } from '../../contexts/themeContext';
import { HttpService } from "../../../apiAuthorization/httpService";
import Card from "../../card/card.js";
import CardBody from "../../card/cardBody.js";
import UserPOSAccountAdd from "../user/userPOSAccountAdd";
import AlertDialog from '../../common/alertDialog';
import ConfirmDialog from '../../common/confirmDialog';
import SmallMenu from '../../header/smallMenu';
import StatusIcon from '../../common/statusIcon';

const useStyles = makeStyles(styles);
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function UserPOSAccountList(props) {
    const classes = useStyles();
    const { theme } = useContext(Theme);
    const userName = props.model.length === 0 ? "" : props.model.userName;
    const [id, setId] = useState(0);
    const [posSites, setPosSites] = useState([]);
    const [isAttendant, setIsAttendant] = useState([]);
    const [isManager, setIsManager] = useState([]);
    const [isAttritionAssociate, setIsAttritionAssociate] = useState([]);
    const [recordToBeEdit, setRecordToBeEdit] = useState([]);
    const [addSiteOpen, setAddSiteOpen] = useState(false);
    const [alertOpen, setAlertOpen] = React.useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [severity, setSeverity] = React.useState('');
    const [errorMessage, setErrorMessage] = React.useState('');
    const [backDrop, setBackDrop] = useState(true);
    const currentTheme = theme ? createMuiTheme(GlobalTheme[theme]) : createMuiTheme(GlobalTheme[localStorage.getItem("theme")]);

    const rowStyle = (rowIndex) => {
        return { color: currentTheme.text, background: rowIndex % 2 === 0 ? '' : currentTheme.alternateGridRow };
    };

    const alertClose = () => {
        setAlertOpen(false);
    };

    const confirmClose = () => {
        setConfirmOpen(false);
    };

    const openUserPOSAccountAdd = () => {
        setAddSiteOpen(true);
        setRecordToBeEdit(props.model);
    };

    const closeUserPOSAccountAdd = () => {
        setAddSiteOpen(false);
    };

    const closeUserPOSAccount = () => {
        props.parentCallback();
    };

    const updateList = (item) => {
        if (item !== null) {
            const data = posSites;
            data.push(item);
            setPosSites(data);
        }
    };

    const deletePOSConfirm = (id) => {
        setId(id);
        setConfirmOpen(true);
    };

    const deletePOSAccount = () => {
        setConfirmOpen(false);
        setBackDrop(true);
        HttpService.post('/User/SavePOSAccount', {
            Id: id
        })
        .then((result) => {
            setBackDrop(false);
            if (result.error) {
                setErrorMessage(result.message);
                setSeverity('error');
                setAlertOpen(true);
            }
            else {
                const data = posSites.filter(item => item.Id !== id);
                setPosSites(data);
            }
        },
        (error) => {
            console.log(error);
        });
    };

    const savePOSAccount = (item, checked, attendantChecked, IsManagerchecked, IsAttritionAssociate) => {
        setBackDrop(true);
        //if (attendantChecked)
        //    item.IsAttendant = checked;
        //else
        //    item.IsManager = checked;

        if (attendantChecked)
            item.IsAttendant = checked;

        if (IsManagerchecked)
            item.IsManager = checked;

        if (IsAttritionAssociate)
            item.IsAttritionAssociate = checked;

        HttpService.post('/User/SetAttendantOrManager', {
            Id: item.Id,
            AppUserName: item.AppUserName,
            IsAttendant: item.IsAttendant,
            IsManager: item.IsManager,
            IsAttritionAssociate: item.IsAttritionAssociate
        })
        .then((result) => {
            setBackDrop(false);
        },
        (error) => {
            console.log(error);
        });
    };    

    const getPOSSites = () => {
        HttpService.post('/User/GetPOSAccounts', {
            AppUserName: userName
        })
        .then((result) => {
            setPosSites(result.data);
            setBackDrop(false);
        },
        (error) => {
            console.log(error);
        });
    };

    useEffect(() => {
        getPOSSites();
        // eslint-disable-next-line
    }, []);

    const fetchData = () => {
        return (
            <React.Fragment>
                <ThemeProvider theme={currentTheme}>
                    <CssBaseline />
                    <Backdrop className={classes.backdrop} id="posListBackdrop" open={backDrop}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    <Dialog zindex="100" fullScreen open={addSiteOpen} onClose={closeUserPOSAccountAdd} TransitionComponent={Transition}>
                        <UserPOSAccountAdd parentCallback={closeUserPOSAccountAdd}
                            refreshGrid={updateList}
                            model={recordToBeEdit}
                        />
                    </Dialog>
                    <Container maxWidth="xl" style={{ height: '95%' }} className={props.styles}>
                        <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
                            <Toolbar>
                                <IconButton edge="start" color="inherit" onClick={closeUserPOSAccount} aria-label="back">
                                    <KeyboardBackspaceIcon />
                                </IconButton>
                                <Grid container direction="row" alignItems="center">
                                    <Grid item>
                                        <Typography variant="h6" className={classes.title}>POS Settings</Typography>
                                    </Grid>
                                    <Grid item>
                                        <StatusIcon />
                                    </Grid>
                                </Grid>
                                <Grid container justify="flex-end">
                                    <Fab style={{ background: currentTheme.secondary, color: "white" }} size="small" aria-label="add" onClick={openUserPOSAccountAdd}>
                                        <AddIcon />
                                    </Fab>
                                    <SmallMenu modified={false} />
                                </Grid>
                            </Toolbar>
                        </AppBar>
                        <Card color="primary" style={{ height: '100%', background: currentTheme.background }}>
                            <CardBody style={{ color: currentTheme.text, marginTop: "50px" }}>
                                <div className="react-bootstrap-table" style={{ overflowY: "auto", scrollBehavior: "smooth", position: "absolute", top: "15px", bottom: "15px", left: "15px", right: "15px" }}>
                                    <table className="table table-hover table-bordered">
                                        <thead>
                                            <tr>
                                                <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground, width: "50px" }}>#</th>
                                                <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground }}>Name</th>
                                                <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground, textAlign: "center" }}>Attendant</th>
                                                <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground, textAlign: "center" }}>Manager</th>
                                                <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground, textAlign: "center" }}>AttritionAssociate</th>
                                                <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground, }}></th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-capitalize">
                                            {posSites?.map((item, index) => (
                                                <tr key={item.Id}>
                                                    <td style={rowStyle(index)}>{index + 1}</td>
                                                    <td style={rowStyle(index)}>{item.LocationPath}</td>
                                                    <td style={rowStyle(index)} align="center">
                                                        <FormControlLabel
                                                            label=""
                                                            control={
                                                                <Checkbox
                                                                    name={"chkAttendant" + item.Id}
                                                                    checked={item.IsAttendant}
                                                                    onChange={(e) => setIsAttendant({ ...isAttendant, [e.target.name]: e.target.checked })}
                                                                    onClick={e => savePOSAccount(item, e.target.checked, 1, 0, 0)}
                                                                    color="primary"
                                                                    style={{ paddingTop: "0px", paddingBottom: "0px" }}
                                                                />
                                                            }
                                                        />
                                                    </td>
                                                    <td style={rowStyle(index)} align="center">
                                                        <FormControlLabel
                                                            label=""
                                                            control={
                                                                <Checkbox
                                                                    name={"chkManager" + item.Id}
                                                                    checked={item.IsManager}
                                                                    onChange={(e) => setIsManager({ ...isManager, [e.target.name]: e.target.checked })}
                                                                    onClick={e => savePOSAccount(item, e.target.checked, 0, 1, 0)}
                                                                    color="primary"
                                                                    style={{ paddingTop: "0px", paddingBottom: "0px" }}
                                                                />
                                                            }
                                                        />
                                                    </td>
                                                    <td style={rowStyle(index)} align="center">
                                                        <FormControlLabel
                                                            label=""
                                                            control={
                                                                <Checkbox
                                                                    name={"chkIsAttritionAssociate" + item.Id}
                                                                    checked={item.IsAttritionAssociate}
                                                                    onChange={(e) => setIsAttritionAssociate({ ...isAttritionAssociate, [e.target.name]: e.target.checked })}
                                                                    onClick={e => savePOSAccount(item, e.target.checked, 0, 0, 1)}
                                                                    color="primary"
                                                                    style={{ paddingTop: "0px", paddingBottom: "0px" }}
                                                                />
                                                            }
                                                        />
                                                    </td>
                                                    <td style={rowStyle(index)}>
                                                        <Tooltip title="Delete" arrow>
                                                            <DeleteIcon style={{ color: currentTheme.secondary, cursor: 'pointer', float: 'right' }} onClick={() => deletePOSConfirm(item.Id)} />
                                                        </Tooltip>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <ConfirmDialog open={confirmOpen} close={confirmClose} onConfirm={deletePOSAccount}
                                    title="Delete POS Site" message="Are you sure you want to delete the selected POS site?" />
                                <AlertDialog open={alertOpen} close={alertClose} message={errorMessage} severity={severity} />
                            </CardBody>
                        </Card>
                    </Container>
                </ThemeProvider>
            </React.Fragment>
        );
    }

    let content = fetchData();
    return (
        <>
            {content}
        </>
    );
}
